import {
  Datatable,
  DatatableBody,
  DatatableHead,
  DatatableHeader,
  DatatableRow,
} from '@monksflow/monks-ui';
import type { AnalysisListItem } from '@/entities/analysis';
import { AnalysisTableRow } from './AnalysisTableRow';
import { useTranslation } from 'react-i18next';

interface AnalysisTableProps {
  analyses: AnalysisListItem[];
  onRetry: (id: string) => void;
  onDelete: (id: string, options?: { onSettled?: () => void }) => void;
  retryingId?: string;
  deletingId?: string;
}

// The creator rides in the Created cell rather than a column of its own. Market has no
// column yet, though the list endpoint now carries it.
const AnalysisTableHeader = () => {
  const { t } = useTranslation('analysis');
  return (
    <DatatableHeader>
      <DatatableRow>
        <DatatableHead scope="col" className="w-[55%] text-xs text-muted-foreground">
          {t('analysis.analysisTable.report')}
        </DatatableHead>
        <DatatableHead scope="col" className="w-[18%] text-xs text-muted-foreground">
          {t('analysis.analysisTable.status')}
        </DatatableHead>
        <DatatableHead scope="col" className="w-[18%] text-xs text-muted-foreground">
          {t('analysis.analysisTable.created')}
        </DatatableHead>
        <DatatableHead scope="col" className="w-[10%] text-xs text-muted-foreground">
          <span className="sr-only">{t('analysis.analysisTable.actions')}</span>
        </DatatableHead>
      </DatatableRow>
    </DatatableHeader>
  );
};

export function AnalysisTable({
  analyses,
  onRetry,
  onDelete,
  retryingId,
  deletingId,
}: AnalysisTableProps) {
  return (
    <Datatable className="w-full table-fixed [&_thead_th]:border-b">
      <AnalysisTableHeader />
      <DatatableBody>
        {analyses.map((analysis, index) => (
          <AnalysisTableRow
            key={analysis.id}
            analysis={analysis}
            index={index}
            onRetry={onRetry}
            onDelete={onDelete}
            isRetrying={retryingId === analysis.id}
            isDeleting={deletingId === analysis.id}
          />
        ))}
      </DatatableBody>
    </Datatable>
  );
}
